import { render, staticRenderFns } from "./extract-products.vue?vue&type=template&id=21e5fe72"
import script from "./extract-products.vue?vue&type=script&lang=js"
export * from "./extract-products.vue?vue&type=script&lang=js"
import style0 from "./extract-products.vue?vue&type=style&index=0&id=21e5fe72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports